import Model from './Model'

export default class Ingredient extends Model {
  resource() {
    return 'ingredients'
  }
}
